export default __webpack_public_path__ + "static/media/02_reeach-maker_tour_navigation.421367ae.mp4";